export const MINUTES_PER_DAY = 24 * 60;
/**
 * Parses a human duration into whole minutes. Accepted forms:
 *  - `2h 30m`, `2h30m`, `2h`, `30m`, `90 min`
 *  - `2:30` (h:mm)
 *  - `2.5`, `2,5` (decimal hours)
 *  - `150` (bare number > 24 is read as minutes; ≤ 24 as hours)
 * Returns `null` when the input cannot be parsed. Rounds to the nearest minute.
 */
export function parseDuration(input) {
    const s = input.trim().toLowerCase().replace(/\s+/g, '');
    if (!s)
        return null;
    // h:mm
    const colon = /^(\d{1,3}):(\d{1,2})$/.exec(s);
    if (colon) {
        const h = Number(colon[1]);
        const m = Number(colon[2]);
        if (m >= 60)
            return null;
        return h * 60 + m;
    }
    // 2h30m / 2h / 30m / 90min
    const hm = /^(?:(\d+(?:[.,]\d+)?)h)?(?:(\d+)(?:m|min|mins))?$/.exec(s);
    if (hm && (hm[1] !== undefined || hm[2] !== undefined)) {
        const h = hm[1] ? Number(hm[1].replace(',', '.')) : 0;
        const m = hm[2] ? Number(hm[2]) : 0;
        return Math.round(h * 60 + m);
    }
    // bare number: decimal hours, or minutes when > 24
    const num = /^(\d+(?:[.,]\d+)?)$/.exec(s);
    if (num) {
        const n = Number(num[1].replace(',', '.'));
        if (Number.isInteger(n) && n > 24)
            return n;
        return Math.round(n * 60);
    }
    return null;
}
/** Formats minutes as `7.50` (DECIMAL) or `07:30` (HH_MM). */
export function formatDuration(minutes, format = 'DECIMAL') {
    const safe = Math.max(0, Math.round(minutes));
    if (format === 'HH_MM') {
        const h = Math.floor(safe / 60);
        const m = safe % 60;
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    }
    return (safe / 60).toFixed(2);
}
/** Decimal hours with two decimals, as a number (used for xlsx cells and chart values). */
export function minutesToHours(minutes) {
    return Math.round((minutes / 60) * 100) / 100;
}
//# sourceMappingURL=duration.js.map